module.exports = __webpack_public_path__ + "img/5.248b3dc9.png";